import { Grid } from '@mui/material';

// This provides the layout of the page and map and sidebar components are passed in as props
export const InventoryItemsLayout = ({ map, sidebar }: { map: React.ReactNode; sidebar: React.ReactNode }) => (
  <Grid container sx={{ height: 'calc(100vh - 64px)' }}>
    <Grid xs={9} md={9} sx={{ minHeight: 0 }}>
      {map}
    </Grid>
    <Grid xs={3} md={3} sx={{
      minHeight: 0, display: 'flex', flexDirection: 'column', borderLeft: 1, borderColor: 'divider', overflow: 'hidden',
    }}
    >
      {sidebar}
    </Grid>
  </Grid>
);
